import { decorate, observable, action } from 'mobx';

export class HeaderStore {
    title = '';
    show = true;

    setTitle = title => {
        this.title = title;
    };
}

decorate(HeaderStore, {
    title: observable,
    show: observable,
    setTitle: action,
});
